import loaderGIF from "@assets/loader.webp";
import { isDev } from "@helpers/utils";
import { ActionIcon, Image, Modal, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconRefresh, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLoaderStore } from "./useLoader.hook";

const ModalLoader: React.FC = () => {
  const [opened, { open, close }] = useDisclosure(false, {
    onOpen: () => setTooLong(false),
    onClose: () => setTooLong(false),
  });
  const [tooLong, setTooLong] = useState(false);
  const loaderStore = useLoaderStore();

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (loaderStore.isLoadingByModal()) {
      open();
      timeout = setTimeout(() => {
        setTooLong(true);
      }, 32000);
    } else {
      close();
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [loaderStore, open, close]);

  return (
    <Modal
      centered
      classNames={{
        content: "bg-transparent",
      }}
      closeOnClickOutside={false}
      closeOnEscape={false}
      opened={opened}
      overlayProps={{
        blur: 3,
      }}
      withCloseButton={false}
      onClose={close}
    >
      <Stack align="center" justify="center">
        <Image
          alt="secret smurfs loader"
          src={loaderGIF}
          title="secret smurfs loader"
        />
        {tooLong && (
          <ActionIcon onClick={() => window.location.reload()}>
            <IconRefresh />
          </ActionIcon>
        )}
        {isDev() && (
          <ActionIcon onClick={close}>
            <IconX />
          </ActionIcon>
        )}
      </Stack>
    </Modal>
  );
};

export default ModalLoader;
